import angular from 'angular';
import RequestLoadingAnimationService from '@/shared/services/RequestLoadingAnimationService';
import eventBus from 'pubsub-js';

angular.module('commonServices').factory('loadingAnimationSvc', [
  '$timeout',
  function($timeout) {
    var loadingAnimation = {
      showSmall: false,
    };

    // we use the event bus because the loading animation is displayed in an angularjs component and if we listen to the service directly it doesn't automatically update the animation ($scope.watch doesnt work)
    eventBus.subscribe('showLoadingAnimationChanged', function(msg, data) {
      $timeout(function() {
        loadingAnimation.showSmall = data;
      }, 100);
    });

    function getLoadingAnimation() {
      return loadingAnimation;
    }

    function setSmallLoadingAnimation(value) {
      loadingAnimation.showSmall = value;
    }

    function showSmallLoadingAnimation() {
      loadingAnimation.showSmall = true;
    }

    function hideSmallLoadingAnimation() {
      loadingAnimation.showSmall = false;
    }

    return {
      getLoadingAnimation: getLoadingAnimation,
      setSmallLoadingAnimation: setSmallLoadingAnimation,
      showSmallLoadingAnimation: showSmallLoadingAnimation,
      hideSmallLoadingAnimation: hideSmallLoadingAnimation,
    };
  },
]);
